import React, { useState, useEffect } from 'react';
import { Modal, Button, Stack } from 'react-bootstrap';
import { ExclamationTriangleFill, CheckLg } from 'react-bootstrap-icons';

const STATUS_OPTIONS = [
  ['Everyone is here', 'success'],
  ['Someone is missing', 'warning'],
  ['Need medical attention', 'danger'],
];

const ReportStatusModal = ({
  show,
  onHide,
  onSave,
  initial = [],
}) => {
  const [selected, setSelected] = useState(initial);

  useEffect(() => {
    if (show) setSelected(initial);
  }, [show, initial]);

  const toggle = (label) =>
    setSelected((prev) =>
      prev.includes(label) ? prev.filter((l) => l !== label) : [...prev, label]
    );

  const handleSave = () => {
    onSave?.(selected);
    onHide();
  };

 

  return (
    <Modal show={show} onHide={onHide} centered size="sm">
      <Modal.Header className="py-2 px-3" closeButton>
        <Button
          variant="outline-warning"
          className="w-100 d-flex align-items-center justify-content-center gap-2"
          disabled
        >
          <ExclamationTriangleFill size={18} />
          My Status
        </Button>
      </Modal.Header>

      <Modal.Body className="pt-2 pb-3">
        <Stack gap={2}>
          {STATUS_OPTIONS.map(([label, varnt]) => {
            const active = selected.includes(label);

            return (
              <Button
                key={label}
                variant={`outline-${varnt}`}
                className="d-flex justify-content-between"
                active={active}
                onClick={() => toggle(label)}
              >
                <span>{label}</span>
                {active && <CheckLg />}
              </Button>
            );
          })}

 
        </Stack>
      </Modal.Body>

      <Modal.Footer className="py-2">
        <Button
          variant="primary"
          className="w-100 py-1"
          onClick={handleSave}
        >
          Use Selection
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportStatusModal;